import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
import { SafeString } from 'handlebars';
import { helpArticleUrl } from 'uplisting-frontend/utils/help-articles';

export default helper(function ([topic, text]: [string, string]): SafeString {
  const href = helpArticleUrl(topic);

  return htmlSafe(
    `<a class="faq-link" target="_blank" rel="noopener noreferrer" href="${href}">${text}</a>`,
  );
});
